import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
    Button,
    Card,
    CardBody,
    Container,
    Row,
    Col,
    Form,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
} from "reactstrap";
// core components
import Header from "dashboard/general-management/components/Headers/Header.js";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from 'axios';
import {api} from '../../../../api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import Cookies from 'js-cookie';

const EditVendor = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [showAddClientModal, setShowAddClientModal] = useState(false); // New state for Add Project modal
    const [clientForm, setClientForm] = useState({});

    const toggleModal = () => setModalOpen(prevState => !prevState);
    const toggleAddClientModal = () => setShowAddClientModal(prevState => !prevState); // Function to toggle Add Project modal

    

    // getting id for client to edit
    const {id} = useParams();

    const [updateValue, setupdateValues] = useState({
        vendor_id: id,
        vendor_name: '',
        vendor_email: '',
        vendor_number: '',
        vendor_website: '',
        vendor_address: '',
        vendor_image: ''
    })

    // Add state for success alert
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() =>{
        const company_id = Cookies.get('company_id');
        api.get(`addVendor.php?vendor_id=${id}&company_id=${company_id}`)
        .then(res =>{
            const vendorData = res.data.vendor;
            setupdateValues({...updateValue, 
                vendor_id: id,  // Explicitly set vendor_id
                vendor_name: vendorData.vendor_name,
                vendor_email: vendorData.vendor_email,
                vendor_number: vendorData.vendor_number,
                vendor_website: vendorData.vendor_website,
                vendor_address: vendorData.vendor_address,
                vendor_image: vendorData.vendor_image
            })
            console.log(res.data)
        })
        .catch(err => console.log(err))
    }, [id]);
    // console.log(updateValue)



    const handleFormSubmit = async(e) => {
        e.preventDefault();

        // Validate required fields
        if (!updateValue.vendor_id || !updateValue.vendor_name) {
            alert('Vendor ID and name are required!');
            return;
        }

        const formdata = new FormData();
        formdata.append("vendor_id", updateValue.vendor_id);
        formdata.append("vendor_name", updateValue.vendor_name);
        formdata.append("vendor_email", updateValue.vendor_email);
        formdata.append("vendor_number", updateValue.vendor_number);
        formdata.append("vendor_website", updateValue.vendor_website);
        formdata.append("vendor_image", updateValue.vendor_image);
        formdata.append("vendor_address", updateValue.vendor_address);

        try {
            const company_id = Cookies.get('company_id');
            formdata.append("company_id", company_id);
            const response = await api.post(`addVendor.php?vendor_id=${id}`, formdata);
            console.log("Data updated successfully:", response.data);
            if(response.data.status === 'success') {
                setSuccessMessage('Vendor updated successfully!');
                setShowSuccessAlert(true);
                setTimeout(() => { window.location.href = '/store-admin/store-management/Vendorlist'; }, 1200);
            } else {
                alert(response.data.message || 'Failed to update vendor');
            }
        } catch (error) {
            console.error("Error updating data:", error);
            alert('An error occurred while updating the vendor');
        }
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setupdateValues(prevState => ({
            ...prevState,
            [name]: value
        }));
        console.log(updateValue)
    };
    const [profileImage, setProfileImage] = useState(null);

  
    const handleFileUpload = (event) => {
      const file = event.target.files[0];
  
      // Check if a file is selected
      if (file) {
        console.log(file);
        setProfileImage(URL.createObjectURL(file));
        // You can also send the file to the server here if needed
        setupdateValues({ ...updateValue, vendor_image: event.target.files[0] });
      }
    };

    

    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
            <Col className="order-xl-2 mb-5 mb-xl-0 text-center  mb-5">
                        <h1>Edit Vendor Details</h1>
                    </Col>
                    <Link to="/store-admin/store-management/Vendorlist"> <Button className='ml-5' style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}>Back</Button></Link>

                <Container className="py-4">
                    
                <div className="p-4 rounded" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
                        <Form onSubmit={handleFormSubmit}>
                            <Row className="justify-content-center align-items-center">
                        <Col lg="12" className="text-center mb-3">
                            {!profileImage && (
                            <div
                                className="profile-image-container"
                                style={{
                                width: '120px',
                                height: '120px',
                                border: '2px solid black',
                                borderRadius: '50%',
                                overflow: 'hidden',
                                boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                                margin: '0 auto',
                                }}
                            >
                                {updateValue.vendor_image &&
                                <img
                                    src={window.location.hostname === 'localhost' 
                                        ? require(`../../../images/${updateValue.vendor_image}`)
                                        : `/images/${updateValue.vendor_image}`}
                                    alt="Vendor"
                                    name="vendor_image"
                                    style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    }}
                                />
                                }
                            </div>
                            )}
                            {profileImage && (
                            <div
                                className="profile-image-container"
                                style={{
                                width: '120px',
                                height: '120px',
                                border: '2px solid black',
                                borderRadius: '50%',
                                overflow: 'hidden',
                                boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                                margin: '0 auto',
                                }}
                            >
                                <img
                                src={profileImage}
                                alt="Profile"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                                />
                            </div>
                            )}
                        </Col>

                        <Col lg="12" className="text-center">
                            <Button
                            style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}
                            onClick={() => document.getElementById('input-profile-image').click()}
                            >
                            <FontAwesomeIcon icon={faPencilAlt} /> Upload Image
                            </Button>

                            <FormGroup style={{ display: 'none' }}>
                            <Input
                                type="file"
                                id="input-profile-image"
                                accept="image/*"
                                onChange={handleFileUpload}
                                
                            />
                            </FormGroup>
                        </Col>
                            </Row><br/>
                            <div className="row">
                            <Col md={6}>
                                <FormGroup>
                                <label className="form-control-label" htmlFor="input-name">Vendor Name</label>
                                <Input
                                    className="form-control-alternative"
                                    id="input-name"
                                    type="text"
                                    name="vendor_name"
                                    defaultValue={updateValue.vendor_name}
                                    onChange={handleInputChange}
                                    placeholder='Vendor Name'
                                />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                <label className="form-control-label" htmlFor="input-name">Vendor Email</label>
                                <Input
                                    className="form-control-alternative"
                                    id="input-name"
                                    type="email"
                                    name="vendor_email"
                                    defaultValue={updateValue.vendor_email}
                                    onChange={handleInputChange}
                                    placeholder='Vendor Email'
                                />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                <label className="form-control-label" htmlFor="input-name">Vendor Number</label>
                                <Input
                                    className="form-control-alternative"
                                    id="input-name"
                                    type="tel"
                                    name="vendor_number"
                                    defaultValue={updateValue.vendor_number}
                                    onChange={handleInputChange}
                                    placeholder='Vendor Number'
                                />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                <label className="form-control-label" htmlFor="input-name">Website</label>
                                <Input
                                    className="form-control-alternative"
                                    id="input-name"
                                    type="url"
                                    name="vendor_website"
                                    defaultValue={updateValue.vendor_website}
                                    onChange={handleInputChange}
                                    placeholder='Vendor Website'
                                />
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                <label className="form-control-label" htmlFor="input-location">Address</label>
                                <Input
                                    className="form-control-alternative"
                                    id="input-name"
                                    type="text"
                                    name="vendor_address"
                                    defaultValue={updateValue.vendor_address}
                                    onChange={handleInputChange}
                                    placeholder='Vendor Address'
                                />
                                </FormGroup>
                            </Col>
                            </div>
                            {/* <Link to="/admin/client"> */}
                            
                            <div className="row">
                                <div className="col-md-12 text-center"> {/* Centered button */}
                               
                                    <Button type="submit" style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}>Submit</Button>
                                    
                                </div>
                            </div>
                        </Form>
                    </div>
                </Container>

            </div>

            {showSuccessAlert && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                    justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
                }}>
                    <div style={{
                        backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
                        maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
                    }}>
                        <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
                        <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
                        <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
                        <Button
                            style={{
                                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                                padding: '10px 25px', borderRadius: '25px'
                            }}
                            onClick={() => setShowSuccessAlert(false)}
                        >OK</Button>
                    </div>
                </div>
            )}

        </>
    );
};

export default EditVendor;
